<template>
  <div class="footer footer2">
    <div class="pub_wrapper">
      <div class="after top">
        <!-- <div class="codes">
          <dl>
            <dt><img src="https://cdn.gda.top/image_after_2019_06/2645/oao.png" /></dt>
            <dd>{{$t("tajik_securities")}}</dd>
          </dl>
        </div> -->
        <div class="leftnav">
          <dl>
            <dt><a href="#">{{$t("about_us")}}</a></dt>
            <dd><a href="/company_introductions">{{$t("company_introductions")}}</a></dd>
            <dd><a href="/organization">{{$t("company_organization")}}</a></dd>
            <dd><a href="/company_culture">{{$t("company_culture")}}</a></dd>
            <dd><a href="/contact_us">{{$t("contact_us")}}</a></dd>
          </dl>

          <dl>
            <dt><a href="#">{{$t("business_introductions")}}</a></dt>
            <dd><a href="/personal_business">{{$t("personal_business")}}</a></dd>
            <dd><a href="/agency_business">{{$t("institutional_business")}}</a></dd>
          </dl>
        </div>
      </div>
      <div class="put_on_record" style="width: 100%; text-align: center; margin-top: -66px; font-size: 14px;">
        <p>Copyright © 2020 Tajik Securities All Rights Reserved.</p>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>
